import { OptionDto } from "@/dtos";

const DispatchFilters = [
    { value: 1, label: 'Actuales', tooltip: 'Visualizar los despachos más recientes' },
    { value: 2, label: 'Histórico', tooltip: 'Visualizar los despachos históricos' }
] as OptionDto[];

export const getDispatchFilters = (): OptionDto[] => {
    return DispatchFilters;
}